module.exports = __webpack_public_path__ + "img/checked.8f8e4805.svg";